import { type GA4 } from "./interfaces";

/**
 * TMeasure an item being added to a shopping cart by sending an add_to_cart event with the relevant items in an items array.
 * @param payload
 */
export async function sendAddToCartDatalayerEvent(
  payload: GA4.AddToCartPayload,
) {
  window.gtag({ ecommerce: null });

  window.gtag({
    event: "add_to_cart",
    ecommerce: payload,
  });
}
